import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Main from "./UI/Main";
import NavFoot from './UI/NavFoot';
import AboutUs from './component/AboutUs';
import ContactUs from './component/ContactUs';
import Program from "./component/Program";
import AnimatedCursor from "react-animated-cursor";
import Form from "./Admission/Form";
import ParentAdmissionForm from "./Admission/ParentAdmissionForm";
import MarketingEnquiry from "./Admission/MarketingEnquiry";
import Login from "./Admin/Login";
import AdminPanel from "./Admin/AdminPanel";
import PdfView from "./Admin/PdfView";
import ViewEnq from "./Admin/enquiry/ViewEnq";
import PrintSingleForm from "./Admin/PrintSingleForm"; // Import the new component
import PrintEnquiryPage from "./Admin/enquiry/PrintEnquiryPage"; // Import new page
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Loader from "./Loader/Loader";
import { AuthProvider } from './utils/AuthContext'; // Adjust the path as necessary
import ProtectedRoute from './utils/ProtectedRoutes'; // Adjust the path as necessary
import AnimatedCursorWrapper from "./Loader/AnimatedCursorWrapper";
import BillDetails from "./Admin/Bill/BillDetails";
import DownloadPage from "./Admin/DownloadPage";
import OverallResipt from "./Admin/OverallResipt";
import DownloadBill from "./Admin/DownloadBill"; // Import the new DownloadBill component
import BranchesCrud from "./Admin/settings/BranchesCrud";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AnimatedCursorWrapper />
        <ScrollToTop />
        <ToastContainer />
        <Routes>
          <Route path="/login" element={<Login />} />
          //protected routes
         {/* <Route path="/admin/manageBranches" element={
    <ProtectedRoute>
      <BranchesCrud />
    </ProtectedRoute>
  }
/> */}
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/overallbill" element={<OverallResipt />} />      
          <Route
            path="/admin/*"
            element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
              {/* <Route
            path="/admin/*"
            element={<ProtectedRoute><BranchesCrud /></ProtectedRoute>} /> */}
          <Route
            path="/form/:id"
            element={<ProtectedRoute><Form /></ProtectedRoute>}
          />
          <Route
            path="/view-enq/:id"
            element={<ProtectedRoute><ViewEnq /></ProtectedRoute>}
          />
          <Route
            path="/pdf/:id"
            element={<ProtectedRoute><PdfView /></ProtectedRoute>}
          />
          <Route
            path="/print-form/:id" // New route for printing a single form
            element={<ProtectedRoute><PrintSingleForm /></ProtectedRoute>}
          />
          <Route
            path="/print-enquiry/:id" // New dedicated print route
            element={<ProtectedRoute><PrintEnquiryPage /></ProtectedRoute>}
          />
          <Route
            path="/admin/downloadBill/:formId/:id" // New route for downloading a single bill
            element={<ProtectedRoute><DownloadBill /></ProtectedRoute>}
          />
          <Route path="/" element={<NavFoot />}>
            <Route index element={<Main />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/Classes" element={<Program />} />
          </Route>
          <Route path="/pdf" element={<ProtectedRoute><PdfView /></ProtectedRoute>} />
          <Route path="/admission" element={<Form />} />
          <Route path="/admission-form" element={<ParentAdmissionForm />} />
          <Route path="/enquiry" element={<MarketingEnquiry />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  
  return null;
};